import profile from '@/views/profile'
import { storage } from '@/services/storage'


const routes = [
    {
        path: '/perfil/',
        name: 'perfil',
        component: profile,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Perfil',
            protect: true
        },
        children: [
            {
                path: ':id',
                name: 'perfil.user',
                component: profile,
                props: true,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Perfil',
                    protect: true,
                },
            }
        ]
    }
]

export { routes };
